import { serializarCsv } from "@/utils/utils";
import type { FiltroListaPayload, ProdutoIdPayload } from "../../dtos/estoque-service.dto";

export function normalizarFiltroListaCsv(valor: FiltroListaPayload | null | undefined): string {
	const valores = Array.isArray(valor) ? valor : [valor];
	return serializarCsv(valores.filter((item) => item !== null && item !== undefined && String(item).trim() !== ""));
}

export function normalizarIdsProdutoCsv(idProdutoCab: ProdutoIdPayload | null | undefined): string {
	return normalizarFiltroListaCsv(idProdutoCab);
}
